module.exports = __webpack_public_path__ + "img/graphic-asset-card-audio.cccbdab8.svg";